// extracted by mini-css-extract-plugin
export default {"Emoji":"bbc_a bhc_i bhc_q bhc_j"};